import imageCompression from "browser-image-compression";

export const getCroppedImg = async (
  imageFile: File,
  croppedAreaPixels: { x: number; y: number; width: number; height: number }
): Promise<File> => {
  const loadImage = (file: File): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = (error) => reject(error);
        img.src = reader.result as string;
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const imageSrc = await loadImage(imageFile);
  const canvas = document.createElement("canvas");
  const scaleX = imageSrc.naturalWidth / imageSrc.width;
  const scaleY = imageSrc.naturalHeight / imageSrc.height;
  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Unable to obtain 2D canvas context");
  }

  ctx.drawImage(
    imageSrc,
    croppedAreaPixels.x * scaleX,
    croppedAreaPixels.y * scaleY,
    croppedAreaPixels.width * scaleX,
    croppedAreaPixels.height * scaleY,
    0,
    0,
    croppedAreaPixels.width,
    croppedAreaPixels.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        // Create a File object from the Blob
        const croppedFile = new File([blob], imageFile.name, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });
        resolve(croppedFile);
      },
      "image/jpeg",
      1 // Quality of the image (optional)
    );
  });
};

export async function compressImage(
  file: File,
  maxSizeMB: number
): Promise<File> {
  const options = {
    maxSizeMB,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    return await imageCompression(file, options);
  } catch (error) {
    console.error(error);
    throw new Error("Failed to compress image");
  }
}
